import { render } from "./AIChat.vue?vue&type=template&id=3b4f4b42&scoped=true"
import script from "./AIChat.vue?vue&type=script&lang=js"
export * from "./AIChat.vue?vue&type=script&lang=js"

import "./AIChat.vue?vue&type=style&index=0&id=3b4f4b42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4f4b42"]])

export default __exports__